import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { PUBLIC_ROUTES } from "routes/routes";

interface DontHaveAccountProps {
  compact?: boolean;
}

export default function DontHaveAccount({ compact = false }: DontHaveAccountProps) {
  const { t } = useTranslation("common");
  const router = useRouter();
  const { query } = router;

  const { invitationCode, redirect } = query;

  return (
    <div className={compact ? "mt-2 w-full pb-0" : "mt-4 w-full pb-1"}>
      <div className="flex w-full justify-center justify-items-center text-center">
        <p
          className={
            compact
              ? "text-sm text-slate-600 dark:text-zinc-400"
              : "text-slate-600 dark:text-zinc-400"
          }
        >
          {t("¿Aún no tienes tu cuenta?")}
        </p>
        <button
          className={`ml-2 cursor-pointer bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text font-semibold text-transparent transition-all duration-200 hover:from-blue-700 hover:to-purple-700 ${
            compact ? "text-sm" : ""
          }`}
          onClick={() =>
            router.push({
              pathname: PUBLIC_ROUTES.register.path,
              query: {
                redirect: redirect as string,
                invitationCode: invitationCode as string
              }
            })
          }
          type="button"
        >
          {t("Crear cuenta")}
        </button>
      </div>
    </div>
  );
}
